import { register } from '../component/register';
register();
